module.exports = __webpack_public_path__ + "static/img/200300.f99f8d46.png";